import { render, staticRenderFns } from "./KeywordTransfer.vue?vue&type=template&id=202b337c&"
import script from "./KeywordTransfer.vue?vue&type=script&lang=ts&"
export * from "./KeywordTransfer.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./KeywordTransfer.vue?vue&type=style&index=0&id=202b337c&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports